import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

export const externalFilter: {
  filters: CompositeFilterDescriptor[];
}[] = [
  {
    filters: [
      {
        logic: 'and',
        filters: [],
      },
    ],
  },
  {
    filters: [
      {
        filters: [{ field: 'isContracted', value: true, operator: 'eq' }],
        logic: 'and',
      },
    ],
  },
];
